export const authHeader = (token: string): { headers: HeadersInit } => ({
  headers: {
    Authorization: `Bearer ${token}`,
  },
});
